import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconFilterRemoveStyle0 = cosmosIconCss;

const CosmosIconFilterRemove$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFilterRemove extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '2ebe8e40d88fb038d3053e9c3f288879ead8f53a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'bc9eb45aea72444e771d04e65ec448c63a8f623c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'be250111f9f5de773af977a39cf657069c9f6a60', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 6.25h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3V9.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v1.75ZM8 11h.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5v-1.75h-4a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h4V11.5A.5.5 0 0 1 8 11ZM3 6.75a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-.5ZM21 16a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm-2.703-1.237a.5.5 0 0 0 0-.707l-.353-.354a.5.5 0 0 0-.707 0l-1.238 1.238-1.237-1.238a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707L14.94 16l-1.24 1.238a.5.5 0 0 0 0 .707l.354.353a.5.5 0 0 0 .707 0l1.237-1.237 1.238 1.237a.5.5 0 0 0 .707 0l.353-.353a.5.5 0 0 0 0-.707L17.06 16l1.237-1.237Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconFilterRemoveStyle0; }
}, [1, "cosmos-icon-filter-remove", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-filter-remove"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-filter-remove":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFilterRemove$1);
            }
            break;
    } });
}

const CosmosIconFilterRemove = CosmosIconFilterRemove$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFilterRemove, defineCustomElement };
